import { USER_ROLES } from "../constants";

const ADDRESS_EDITABLE_COUNTRIES = ["SG", "HK"];

/**
 * Address edits are offered for SG and HK customers.
 * When admin authorization is enabled, only customer_profile_editor admins
 * whose country groups include that customer can open the editor.
 */
export const canEditCustomerAddress = ({
  appCountry,
  assignedRoles,
  assignedCountries,
  authorizationEnabled,
}: {
  appCountry?: string | null;
  assignedRoles: string[] | null;
  assignedCountries: string[] | null;
  authorizationEnabled: boolean;
}): boolean => {
  const country = appCountry?.trim().toUpperCase();
  if (!country || !ADDRESS_EDITABLE_COUNTRIES.includes(country)) {
    return false;
  }

  if (!authorizationEnabled) {
    return true;
  }

  return (
    !!assignedRoles?.includes(USER_ROLES.CUSTOMER_PROFILE_EDITOR) &&
    !!assignedCountries?.includes(country)
  );
};
